<template>
  <div class=" min-h-screen">
    <div class="mb-3">
      <div class="bg-white/60 backdrop-blur-lg rounded-xl shadow-md p-6 flex items-center justify-between">
        <div>
          <span class="text-xl font-bold text-purple-600 inline-block transition-all duration-500">
            <span
                class="bg-clip-text text-transparent bg-gradient-to-r from-purple-500 via-pink-500 to-[#FD6B4B] hover:animate-pulse">
              {{ user.first_name }}
            </span>
          </span>
          <span class="text-sm font-semibold text-gray-800 mr-2">خوش آمدید</span>
          <p class="text-gray-500 mt-2 text-xs">سطح دسترسی:
            <span class="text-green-500 mr-1 font-weight-bold"> انباردار</span>
          </p>
        </div>
        <div class="text-right">
          <div class="inline-flex items-center gap-2">
            <div class="relative h-6 w-6 flex items-center mt-1">
              <svg class="absolute h-7 w-7 text-green-500 animate-spin opacity-100 verification-spinner"
                   xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <svg class="absolute h-7 w-7 text-green-500 opacity-0 verification-check"
                   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
              </svg>
            </div>
            <p class="text-md mt-5  font-weight-bold text-green-500">توکن معتبر</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js';
import ShopOrdersListTable from "@/modules/order_admin/ShopOrdersList";
import OrdersTotal from "@/modules/order_admin/OrdersTotal";

export default {
  name: "StoreKeeperDashboard",
  components: {OrdersTotal, ShopOrdersListTable},
  data() {
    return {
      balance: 0,
    };
  },
  mounted() {
    this.updateBalance()

  },
  methods: {
    updateBalance() {
      this.request({
        url: this.endpoint('finance/walletsBalanceSum'),
        method: "get",
        success: data => {
          this.balance = data.total_balance
          console.log(data)
        }
      })
    },
  }
};
</script>

<style scoped>
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
  transform-origin: center;
}

/* For your verification animation */
.verification-spinner {
  animation: spin 1s linear infinite, verification 2s linear infinite;
}

.verification-check {
  animation: check-animation 2s linear infinite;
}

@keyframes verification {
  0%, 45% { opacity: 1; }
  50%, 100% { opacity: 0; }
}

@keyframes check-animation {
  0%, 45% { opacity: 0; }
  50%, 100% { opacity: 1; }
}
canvas {
  width: 100% !important;
  height: 240px !important;
}
</style>
